export default {
  setUnpaginated({ commit }, data) {
    commit("SET_ITEMS_NO_PAGINATE", data)
  },
  setCategoryReasons({ commit }, data) {
    commit("SET_RANDOM_PHOTOS", data)
  }
}
